var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row align-center"},[_c('div',{staticClass:"sl-title"},[_vm._v("Countries")]),_c('v-btn',{attrs:{"small":"","outlined":""},on:{"click":function($event){return _vm.add()}}},[_vm._v("Add"),_c('v-icon',{attrs:{"small":"","right":""}},[_vm._v("mdi-plus")])],1)],1),_c('Table'),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }